// extracted by mini-css-extract-plugin
export default {"wrap":"Ja-z","heading":"Ka-z","formError":"La-z"};